import { useEffect, useRef } from "react";
import { useInView, animate } from "framer-motion";

export function AnimatedNumber({ value, format, duration = 1.4, className = "" }) {
  const wrapRef = useRef(null);
  const nodeRef = useRef(null);
  const prevRef = useRef(0);
  const inView = useInView(wrapRef, { amount: 0.3 });

  useEffect(() => {
    if (!inView || !nodeRef.current) return;
    const controls = animate(prevRef.current, value, {
      duration,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => {
        prevRef.current = v;
        if (nodeRef.current) nodeRef.current.textContent = format(v);
      },
    });
    return () => controls.stop();
  }, [value, inView, format, duration]);

  return (
    <span ref={wrapRef} className={className}>
      <span ref={nodeRef} data-testid="animated-number">{format(value)}</span>
    </span>
  );
}
